// methods here build URLs for site pages

import utilityService from './utilityService.js'
import dataService from './dataService.js'

export default {
    mixins: [utilityService, dataService],
    methods: {
        loadToolsDraftFromWIF(wifText, wifFilename) {
            return this.postWIFToJSON(wifText).then(resp => {
                this.loadToolsDraftFromJSON(resp.data, wifFilename)
            })
        },

        loadToolsDraftFromJSON(draftJSON, wifFilename) {
            this.setToolsDraftJSON(draftJSON)
            this.setToolsDraftSource(0, wifFilename, wifFilename)
        },

        loadToolsDraftFromPatternId(patternID, isStraightThreading, isStraightTreadling, isPointThreading, isPointTreadling, isTurned, isSingleRepeat, userID, loginToken) {
            return this.getPatternJson(patternID, isStraightThreading, isStraightTreadling, isPointThreading, isPointTreadling, isTurned, isSingleRepeat, userID, loginToken).then(resp => {
                // console.log('1 getPatternJSON')
                this.setToolsDraftJSON(resp.data)
            }).then(() => {
                this.getPattern(patternID).then(resp => {
                    // console.log('2 getPattern')
                    this.setToolsDraftSource(patternID, '', resp.data.DisplayTitle)
                    this.draftTitle = resp.data.DisplayTitle
                })
            })
        },

        loadToolsBlockProfileFromPatternId(patternID, isTurned, userID, loginToken) {
            return this.getPatternProfileJson(patternID, isTurned, userID, loginToken).then(resp => {
                this.setToolsDraftJSON(resp.data)
            }).then(() => {
                this.getPattern(patternID).then(resp => {
                    this.setToolsDraftSource(patternID, '', resp.data.DisplayTitle)
                    this.draftTitle = resp.data.DisplayTitle
                })
            })
        },

        setToolsDraftJSON(draftJSON) {
            this.$store.commit('setEditDraftJSON', draftJSON)
        },

        setToolsDraftSource(patternID, WIFFilename, displayTitle) {
            let wifFilenameNoExt = WIFFilename.toLowerCase().replace('.wif', '')
            let src = { PatternID: patternID, WIFFilename: wifFilenameNoExt, DisplayTitle: displayTitle }
            this.$store.commit('setEditDraftSource', src)
        },

        clearToolsDraftState() {
            this.setToolsDraftJSON(null)
            this.setToolsDraftSource(0, '', '')
        },

        getToolsDraftJSON() {
            return this.$store.state.editDraftJSON
        },

        getToolsDraftOriginalSource() {
            return this.$store.state.editDraftSource
        },

        getToolsDraftSourceMessage() {
            let originalSourceInfo = this.getToolsDraftOriginalSource()
            let message = 'From Handweaving.net'
            if (originalSourceInfo && originalSourceInfo.PatternID && originalSourceInfo.PatternID > 0) {
                message += ' #' + originalSourceInfo.PatternID
            }
            else if (originalSourceInfo && originalSourceInfo.WIFFilename && originalSourceInfo.WIFFilename.length > 0) {
                message += ', ' + originalSourceInfo.WIFFilename
            }
            return message
        },

        getDownloadImageFilename(operationLabel, overrideName) {
            let originalSourceInfo = this.getToolsDraftOriginalSource()
            let downloadFilename = this.getBaseDownloadFilename(originalSourceInfo.PatternID, originalSourceInfo.WIFFilename, operationLabel)
            if (overrideName && overrideName.length > 0) {
                downloadFilename = overrideName
            }
            if (!downloadFilename.toLowerCase().endsWith('.png')) {
                downloadFilename += '.png'
            }
            return downloadFilename
        },

        getDownloadWifFilename(operationLabel, overrideName) {
            let originalSourceInfo = this.getToolsDraftOriginalSource()
            let downloadFilename = this.getBaseDownloadFilename(originalSourceInfo.PatternID, originalSourceInfo.WIFFilename, operationLabel)
            if (overrideName && overrideName.length > 0) {
                downloadFilename = overrideName
            }
            if (!downloadFilename.toLowerCase().endsWith('.wif')) {
                downloadFilename += '.wif'
            }
            return downloadFilename
        }

    }
}
